module.exports = __webpack_public_path__ + "static/media/tutorial-1.0e07c69b.png";